import {Component, OnInit} from '@angular/core';

import {TranslateModule} from '@ngx-translate/core';
import {SecuritySettingsFormComponent} from "../security-settings-form/security-settings-form.component";
import {EmailSettingsFormComponent} from "../email-settings-form/email-settings-form.component";
import {ForwardingSettingsFormComponent} from "../forwarding-settings-form/forwarding-settings-form.component";

/**
 * Settings Component with AXD Branding
 *
 * Uses Angular's new control flow syntax (@if, @for) and enhanced accessibility.
 * Styling follows AXD brand guidelines with responsive design and PrimeNG compatibility.
 */
@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    TranslateModule,
    SecuritySettingsFormComponent,
    EmailSettingsFormComponent,
    ForwardingSettingsFormComponent
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {

  // Stable keys used both as selection identity and translation key, so switching
  // language doesn't break the active-tab comparison.
  options: string[] = [
    'settings.tabs.security',
    'settings.tabs.email',
    'settings.tabs.forwarding',
  ]

  // Default selected option
  selectedOption: string = this.options[0];

  constructor(
  ) { }

  ngOnInit() {
    // Initialize component state
  }

  /**
   * Changes the selected settings tab
   * @param option The option to select
   */
  selectOption(option: string) {
    this.selectedOption = option;
  }
}
